import React from 'react';
import AssetItem from './AssetItem';

const CategoryItem = props => <AssetItem type="category" {...props} />;

export default CategoryItem;
